module.exports = __webpack_public_path__ + "static/img/img26.2700328c.png";